<template>
  <div style="width: 85%;margin: 0 auto ">
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title>دسته بندی ها</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"

                >
                  دسته بندی جدید
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span v-if="editedIndex !== -1" style="font-family: Kalameh" class="headline">ویرایش دسته بندی</span>
                  <span v-else style="font-family: Kalameh" class="headline">دسته بندی جدید</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-text-field
                          v-model="editedItem.title"
                          label="عنوان دسته بندی"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                      >
                        <v-file-input
                          v-model="imageFile"
                          label="تصویر"
                          v-on:change="showImage($event)"
                          v-on:click:clear="deleteImage"
                        ></v-file-input>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.description"
                          label="توضیحات مربوطه"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-img style="max-width: 200px" width="200" height="150" :src="image"></v-img>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    بیخیال
                  </v-btn>
                  <v-btn

                    color="blue darken-1"
                    text
                    @click="save"
                  >
                    ذخیره
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline">آیا مطمئنی این قسمت حذف شود ؟ </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete">بیخیال</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm">قبول</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="blue"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
            color="red"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.image="{item}">
          <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" alt="تصویر دسته" width="70px" height="50px" :src="url+item.image">
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>

    </v-card>

  </div>
</template>

<script>
  import {getCategory , postCategory , deleteCategory , putCategory} from "../../../api/category";
  import {mapActions} from "vuex";
  import {toBase64} from "../../../plugins/toBase64";

  export default {
    name: "category",
    data: () => ({
      imageFile: null,
      url: process.env.VUE_APP_BASE_URL,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'عنوان',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'توضیحات', value: 'description',align: 'start' },
        { text: 'تصویر', value: 'image',align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false,width:'75px',align: 'center' },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        id:0,
        title: null,
        description:null,
        image: null,
      },
      defaultItem: {
        id:0,
        title: null,
        description: null,
        image: null,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'دسته بندی جدید' : 'ویرایش دسته بندی'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted() {
      this.initialize()
    },

    methods: {
      showImage(e){
        if(e) {
          this.image = URL.createObjectURL(e)
        }
      },
      deleteImage()
      {
        this.image = ''
      },
      ...mapActions({
        snackBarAction: 'snackBar/snackBarAction'
      }),
      async initialize () {
        try {
          this.desserts = await getCategory ();
        }
        catch (e) {
          this.snackBarAction({color:"error" , textSnackBar:'متاسفانه عملیات گرفتن داده ها با مشکل روبرو شد', showSnackbar:true})

        }

      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.image=''
        this.imageFile=[]
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
        this.image=''
        this.imageFile=[]
      },

      async deleteItemConfirm () {
        try {
          await deleteCategory(this.editedItem.id)
          this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف با موفقیت اعمال شد', showSnackbar:true})
        }
        catch (e) {
          this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
        }
        await this.initialize()
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.image=''
        this.imageFile=[]
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.image=''
        this.imageFile=[]
      },


      async save () {
        if (this.editedIndex > -1) {
           this.image = this.imageFile ? await toBase64(this.imageFile) : null
          try {
            await putCategory(this.editedItem , this.editedItem.id)
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات ویرایش با موفقیت اعمال شد', showSnackbar:true})
          }
          catch (e) {
            this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          }
        }

        else {
          this.editedItem.image = this.imageFile ? await toBase64(this.imageFile) : null
          try {
             await postCategory(this.editedItem)
             this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات افزودن  با موفقیت اعمال شد', showSnackbar:true})
           }
           catch (e) {
             this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
           }

        }
        this.close()
        await this.initialize()
      },
    },
  }
</script>

<style scoped>

</style>
